export default "__VITE_ASSET__DgrsX8S1__"